export const googlePartnerProfile = "https://www.google.com/partners/agency?id=8411674241";
export const googlePartnerBadge = "https://www.gstatic.com/partners/badge/images/2026/PartnerBadgeClickable.svg";
